export default "__VITE_ASSET__BDjD9uoj__"